import React from 'react';
import { Task } from '../types/Task';
import { Trash2, Circle, CheckCircle2, Calendar } from 'lucide-react';

interface TaskItemProps {
  task: Task;
  onToggle: (id: number) => void;
  onDelete: (id: number) => void;
}

const TaskItem: React.FC<TaskItemProps> = ({ task, onToggle, onDelete }) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className={`task-item ${task.isCompleted ? 'completed' : ''}`}>
      <button
        onClick={() => onToggle(task.id)}
        className="task-checkbox"
        aria-label={task.isCompleted ? 'Mark as incomplete' : 'Mark as complete'}
      >
        {task.isCompleted ? (
          <CheckCircle2 size={28} color="#11998e" />
        ) : (
          <Circle size={28} color="#ccc" />
        )}
      </button>

      <div className="task-content">
        <p className="task-description">{task.description}</p>
        <div className="task-meta">
          <Calendar size={14} />
          <span>{formatDate(task.createdDate)}</span>
        </div>
      </div>

      <button
        onClick={() => onDelete(task.id)}
        className="task-delete"
        aria-label="Delete task"
      >
        <Trash2 size={20} />
      </button>
    </div>
  );
};

export default TaskItem;